<template>
    <div class="tfa-widget">
      <span style="font-size: var(--font-size-3xl);font-weight: 600;color: rgba(255,255,255,1);text-transform: uppercase;">{{ $t('agency_tools') }}</span>
        <div class="tfa-container-wrap">
              <span v-if="getGameConsole==='default'"
                    class="primary-button mr-2" @click="changeLiveMode('preview')"
                    :class="[(this.getViewMode == 'preview') ? 'active-context' : '']"
                    :title="$t('sport')">{{$t('sportcontext')}}
              </span>
            <span v-if="getGameConsole ==='default' && testResult()"
                  class="primary-button mr-2" @click="changeLiveMode('result')"
                  :class="[(this.getViewMode == 'result') ? 'active-context' : '']"
                  :title="$t('result')">{{$t('result')}}
            </span>
            <button v-if="(getCashier || getType==4 || getTerminal ) && quickBetEnabled"
                  class="primary-button mr-2" @click="changeLiveMode('qBet')"
                  :class="[(this.getViewMode == 'qBet') ? 'active-context' : '']"
                  :title="$t('qbet')">
              <svg class="" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="1" y="1" width="14" height="14" rx="3" fill="none"/>
                <path d="M9.5 2.5L5.5 8.5H8.5L7.5 13.5L11.5 7.5H8.5L9.5 2.5Z" fill="currentColor"/>
              </svg>
              <span>
                {{$t('qbet')}}

              </span>
            </button>
            <button v-if="getCashier || getType==4 || getTerminal"
                  class="primary-button mr-2" @click="changeLiveMode('printodds')"
                  :class="[(this.getViewMode == 'printodds') ? 'active-context' : '']"
                  :title="$t('printodds')">
                      <v-icon small class="">mdi-printer</v-icon>
              <span>
                {{$t('printodds')}}

              </span>
            </button>
            <span
                    v-if="getGameConsole==='default'"
                    class="primary-button mr-2" @click="changeLiveMode('detail')"
                    :class="[(this.getViewMode == 'detail') ? 'active-context' : '']"
                    :title="$t('live')">
                {{$t('live')}}
            </span>

<!--            <span v-if="((getCashier === true || getType==='4') && getGameConsole==='marketview')"-->
<!--                  class="primary-button mr-2" @click="changeLiveMode('preview')"-->
<!--                  :class="[(this.getViewMode == 'preview') ? 'active-context' : '']"-->
<!--                  :title="$t('sport')">-->
<!--                {{$t('sportcontext')}}-->
<!--            </span>-->

<!--            <span v-if="((getCashier === true || getType==='4') && getGameConsole==='marketview')"-->
<!--                  class="primary-button mr-2" @click="changeLiveMode('detail')"-->
<!--                  :class="[(this.getViewMode == 'detail') ? 'active-context' : '']"-->
<!--                  :title="$t('live')">-->
<!--                {{$t('live')}}-->
<!--            </span>-->

            <!--<div class="item my-bets" :class="(getQbet)? 'active' : 'deactivated'"  @click="switchQbetSection(true)">
              {{$t('qbet')}}
            </div>
            <div v-if="isPrintOddsVisible" class="item my-bets" :class="(getPrint)? 'active' : 'deactivated'"  @click="switchPrintSection(true)">
              {{$t('printodds')}}
            </div>-->
        </div>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import SwitchDarkMode from "@/components/left_widgets/SwitchDarkMode";
    import ToolbarSettings from "./ToolbarSettings";

    export default {
        name: "Toolbar",
        components: {ToolbarSettings, SwitchDarkMode},
        data: () => ({
            nowTime: ''
        }),
        created() {
            //setInterval(this.getNow, 1000);
        },
        mounted() {
        },
        beforeDestroy() {
        },
        computed: {
            ...mapGetters({
                'getSettings': 'cart/getSettings',
                'getLoading': 'cart/getLoading',
                'getViewMode': 'ui/getViewMode',
                'getCountLive': 'odds/getCountLive',
                'getOddsVariation': 'cart/getOddsVariation',
                'getType': 'user/getType',
                'getTerminal': 'user/getTerminal',
                'getQbet': 'tree/getQbet',
                'getPrint': 'tree/getPrint',
                'getCashier': 'user/getCashier',
                'getResults': 'settings/getResults',
                'getOddsType': 'odds/getOddsType',
                'getGameConsole': 'settings/getGameConsole',
              'quickBetEnabled': 'settings/quickBetEnabled'
            }),
        },
        methods: {
            ...mapActions({
                'setViewMode': 'ui/setViewMode',
                'setStatusQbet': 'tree/setStatusQbet'

            }),
            changeLiveMode(mode) {
                this.setStatusQbet(false)
                this.setViewMode({mode: mode});
            },
            testResult() {
                var user = 2
                //console.log("CASHIER",this.getCashier)
                if (this.getType) {
                    user = +this.getType
                }

                if (this.getCashier) {
                    user = 100
                }

                /*console.log("SI O NO",this.getResults.includes(user))

                console.log("TYYPE",+this.getType)
                console.log("RESULT",this.getResults)*/
                if (this.getResults.includes(user)) {
                    return true
                } else {
                    return false
                }
                /*console.log("user",user)*/
            },
            getNow: function () {
                const today = new Date();
                var gmt = today.getTimezoneOffset() / (-60)
                var locale = ''
                if (gmt > 0) {
                    locale = ' (GMT +' + gmt + ')'
                } else {
                    locale = ' (GMT ' + gmt + ')'
                }
                this.nowTime = today.toLocaleTimeString() + locale
            }
        }
    }
</script>

<style scoped>

.tfa-widget{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 12px;
  width: 100%;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02));
  border: 1px solid rgba(255,255,255,0.08);
  text-align: center;
  animation: fadeInUp-1166efe2 0.4s ease;
  margin-top: 10px;
}

.tfa-widget .primary-button{
  gap: 2px;
}

.tfa-container-wrap{
  display: flex;
}

</style>